import ChipSelector from '@components/ChipSelector/ChipSelector';
import useNoRenderRef from '@hooks/use-no-render-ref';
import { useEffect, useState } from 'react';

import styles from './SuggestionsSection.module.scss';

interface SuggestionsSectionProps {
  options: string[];
  onSelect: (suggestion: string) => void;
  selectedOption: string | undefined;
  subject: 'label' | 'title';
}

function useSuggestionsSection(
  value: string,
  options: string[],
): [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] {
  const [selectedOption, setSelectedOption] = useState<string>();
  const optionsRef = useNoRenderRef(options);

  useEffect(() => {
    if (optionsRef.current.includes(value)) {
      setSelectedOption(value);
    } else setSelectedOption(undefined);
  }, [optionsRef, value]);

  return [selectedOption, setSelectedOption];
}

const SuggestionsSection: React.FC<React.PropsWithChildren<SuggestionsSectionProps>> = ({
  options,
  onSelect,
  selectedOption,
  subject,
}) => {
  return (
    <div className={styles['suggestions-section']}>
      <div className={styles['suggestions-title']}>Here are some suggestions for your {subject}:</div>
      <div className={styles['suggestions-container']}>
        <ChipSelector
          mode="single"
          options={options}
          onSelect={onSelect}
          selectedOption={selectedOption}
          color="subtle"
          size="medium"
        />
      </div>
    </div>
  );
};

export default SuggestionsSection;
export { useSuggestionsSection };
